import { type CheckboxProps } from '@mui/material/Checkbox/Checkbox'
import { useTheme } from '@mui/material/styles'
import React, { type ReactElement, useMemo } from 'react'
import { Checkbox } from '@mui/material'
import { ReactComponent as UncheckedIcon } from 'assets/checkboxUnchecked.svg'
import { ReactComponent as UncheckedSecondaryIcon } from 'assets/checkboxSecondaryUnchecked.svg'
import { ReactComponent as CheckboxAllUnchecked } from 'assets/checkboxAllUnchecked.svg'

import { ReactComponent as CheckedIcon } from '../../assets/checkboxChecked.svg'

interface ThemeCheckboxProps extends CheckboxProps {
  variant?: 'primary' | 'secondary' | 'all'
  size?: 'small' | 'medium'
}

const ThemeCheckbox: React.FC<ThemeCheckboxProps> = ({
  variant = 'primary',
  size = 'small',
  ...rest
}): ReactElement => {
  const { palette } = useTheme()

  const sizeNumber = size === 'small' ? 15 : 22
  const icon = useMemo<React.ReactNode>(() => {
    if (variant === 'all') {
      return <CheckboxAllUnchecked height={sizeNumber} width={sizeNumber} />
    } else if (variant === 'secondary') {
      return <UncheckedSecondaryIcon height={sizeNumber} width={sizeNumber} />
    }
    return <UncheckedIcon height={sizeNumber} width={sizeNumber} />
  }, [variant])

  return (
    <Checkbox
      sx={{
        '& .MuiSvgIcon-root': { fontSize: 15 },
        padding: '2px',
        '& .MuiTouchRipple-root': { borderRadius: '2px' },
        borderRadius: '2px',
        '&:hover': {
          backgroundColor: palette.blue600.main,
          '& svg': { stroke: palette.charts.purple100.main },
        },
      }}
      checkedIcon={<CheckedIcon height={sizeNumber} width={sizeNumber} />}
      icon={icon}
      {...rest}
    />
  )
}

export default ThemeCheckbox
